// extracted by mini-css-extract-plugin
module.exports = {"landingpage":"Landingpage_landingpage__Usmg9"};